import React, { Component } from "react";
import { MnemoLoading, Title, SuccessNotification } from "components/misc";
import { Button, Container } from "design-react-kit";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import { MTable } from "components/table";

class ImportFromGomp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedFile: null, // Stato per il file selezionato
      rndKey: Math.random(), // Chiave casuale per forzare il re-render della tabella
      payload: [], // Dati corsisti già in piattaforma
    };
  }

  tableConfig = {
    columns: [
      {
        id: "Cognome",
        Header: "cognome",
        accessor: "Cognome",
      },
      {
        id: "Nome",
        Header: "nome",
        accessor: "Nome",
      },
      {
        id: "DataNascita",
        Header: "data di nascita",
        accessor: (row) => {
          return row.DataNascita ? dateHelper.toITDate(row.DataNascita) : "";
        },
      },
      {
        id: "CodiceFiscale",
        Header: "codice fiscale",
        accessor: "CodiceFiscale",
      },
      {
        id: "CorsoDiStudio",
        Header: "Codice Iterno GOMP",
        accessor: "CorsoDiStudio",
      },
      {
        id: "StudenteID",
        Header: "StudenteID GOMP",
        accessor: "StudenteID",
      },
    ],
    /*actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => { alert(); },
      },
    ],*/
  };

  //--- ---

  // Funzione per analizzare il contenuto del file selezionato
  previewFile = async () => {
    const { selectedFile } = this.state;
    if (!selectedFile) return;
    this.setState({ loading: true });

    try {
      const fileContent = await selectedFile.text();
      const jsonData = JSON.parse(fileContent);

      if (jsonData?.Data?.length > 0) {
        const allStudents = jsonData.Data.flatMap((item) => {
          if (item?.Students?.length > 0) {
            return item.Students.map((student) => {
              student.CodiceFiscale = (student.CodiceFiscale || "")
                .replace(/\s/g, "")
                .replace("MN:", "");

              student.CorsoDiStudio = item.CodiceInterno;
              student.syncStatus = "toSync";

              return student;
            });
          }
          return [];
        });

        this.setState({
          payload: allStudents,
          rndKey: Math.random(), // Forza il re-render della tabella
        });
      }

      this.setState({ loading: false });
    } catch (error) {
      console.error("Errore durante l'analisi del file:", error);
      this.setState({ loading: false });
      return;
    }
  }; //  previewFile

  // Funzione per inserire i dati nella piattaforma
  insertData = async () => {
    const { payload } = this.state;
    if (payload.length === 0) return;
    this.setState({ loading: true });

    adminService
      .importFromGOMP(payload, process.env.REACT_APP_AA_YEAR)
      .then(({ data }) => {
        SuccessNotification.render(
          "Importazione andata a buon fine.",
          "Comunicazione",
        );

        this.setState({
          loading: false,
          selectedFile: null,
          payload: [],
          rndKey: Math.random(), // Forza il re-render della tabella
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          selectedFile: null,
        });

        networkErrorHelper.notify(error);
        console.log(error);
      });
  }; // insertData

  // Funzione per inviare il file all'API
  uploadFile = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) return;
    this.setState({ loading: true });
  };

  // Funzione per confermare i bandi
  doBandoConfirm = async () => {
    this.setState({ loading: true });

    adminService
      .confirmBando(process.env.REACT_APP_AA_YEAR)
      .then(({ data }) => {
        SuccessNotification.render(
          "Bandi confermati con successo.",
          "Comunicazione",
        );  
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        networkErrorHelper.notify(error);
        console.log(error);
      });
  };

  //--- ---

  render() {
    const { loading, selectedFile, payload } = this.state;

    return (
      <div className="container mt-3 mb-4">
        <section className="my-4">
          {loading ? (
            <MnemoLoading />
          ) : (
            <Container>
              <Title>Importazione Anagrafiche GOMP (TFA Indire):</Title>

              {/* Bottone conferma bando/confirm  */}
              <section className="m-0 p-0">
                <button
                  className="btn btn-primary"
                  onClick={() => this.doBandoConfirm()}
                >
                  CONFERMA BANDI
                </button>
              </section>

              <hr />

              {payload.length === 0 ? (
                <div className="mt-4">
                  <div className="uploadForm">
                    {/* Input file nascosto */}
                    <input
                      className="uploadFormFile"
                      type="file"
                      accept=".json"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        this.setState({ selectedFile: file });
                      }}
                      style={{ display: "none" }}
                      ref={(input) => (this.fileInput = input)}
                    />

                    {/* Bottone per selezionare il file */}
                    <div className="wrapperUploadBtn">
                      <button
                        className="btn btn-primary bg-dark"
                        onClick={() => this.fileInput.click()}
                      >
                        Seleziona un file da importare
                      </button>

                      {selectedFile && (
                        <p className="uploadFileName">{selectedFile.name}</p>
                      )}
                    </div>

                    <button
                      className="btn btn-primary bg-dark"
                      onClick={this.previewFile}
                      disabled={!selectedFile}
                    >
                      ANTEPRIMA FILE
                    </button>

                    {/* Bottone per caricare il file 
                  <button
                    className="btn btn-primary bg-dark"
                    onClick={this.uploadFile}
                    disabled={!selectedFile}
                  >
                    IMPORTA FILE
                  </button>*/}
                  </div>
                </div>
              ) : (
                <div className="mt-4">
                  <Button
                    color="primary bg-danger m-2"
                    onClick={() => {
                      this.setState({
                        payload: [],
                        selectedFile: null,
                        rndKey: Math.random(), // Forza il re-render della tabella
                      });
                    }}
                  >
                    RESET
                  </Button>

                  <Button
                    color="primary bg-dark m-2"
                    onClick={() => {
                      this.insertData();
                    }}
                  >
                    INSERISCI {payload.length} CORSISTI
                  </Button>
                </div>
              )}

              <hr />

              <div className="mt-4">
                <h2>corsisti da importare</h2>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payload}
                  tableConfig={this.tableConfig}
                />
              </div>
            </Container>
          )}
        </section>
      </div>
    );
  }
}

export default withRouter(ImportFromGomp);
